import React = require("react");
import {isMobile, isTablet} from "react-device-detect";
import "./horizontal-scrollbar.scss";

interface ScrollbarState {
    scrollbarWidth: string;
    scrollBarXOffset: string;
    scrollBarActive: boolean;
    scrollbarDisplay: boolean;

    container: HTMLDivElement;
    content: HTMLDivElement;
    scrollbar: HTMLDivElement;

}

export class HorizontalScrollbar extends React.Component<{}, ScrollbarState> {

    constructor(props) {
        super(props);

        this.state = {
            scrollbarWidth: "0",
            scrollBarXOffset: "0",
            scrollBarActive: true,
            scrollbarDisplay: false,

            container: undefined,
            content: undefined,
            scrollbar: undefined,
        };
    }

    public componentDidMount() {

        // after component render, update scrollbar
        const container = (this.refs.container as HTMLDivElement);
        const content = (this.refs.content as HTMLDivElement);
        const scrollbar = (this.refs.scrollbar as HTMLDivElement);

        // drag functionality for scrollbar!
        scrollbar.onmousedown = () => {
            this.disableAppTextSelect();
            if (!(isTablet || isMobile)) {
                scrollbar.classList.add("active");

                document.onmousemove = (moveEvent) => {
                    const percentScreenChange = moveEvent.movementX / window.innerWidth;
                    const pixelChangeInContent = content.scrollWidth * percentScreenChange;
                    content.scrollLeft = content.scrollLeft + pixelChangeInContent * 2;
                };

                document.onmouseup = () => {
                    scrollbar.onmouseup = null;
                    document.onmousemove = null;
                    scrollbar.classList.remove("active");
                    this.enableAppTextSelect();
                };
            }
        };

        const data = { // use function in order to prevent re-render on state-change
            container,
            content,
            scrollbar,
        };

        this.updateViewScrollbar(data);
    }

    public updateViewScrollbar(data) {

        const containerBoundingRect = data.container.getBoundingClientRect() as any;
        const contentBoundingRect = data.content.getBoundingClientRect() as any;

        const scrollbarWidth = contentBoundingRect.width / data.content.scrollWidth;

        let scrollbarXOffset;
        let displayScrollbar = true;

        if (scrollbarWidth < 0.99) {
            // Calculate the offset in the div and transform based on the containers position in the screen.
            // This is done because positioning relative-absolute created rendering problems.
            const maxContentTravel = data.content.scrollWidth - contentBoundingRect.width;
            const hasTraveled = data.content.scrollLeft;
            const percentTraveled = hasTraveled / maxContentTravel;
            const maxScrollbarTravel =
                containerBoundingRect.width * (1 - scrollbarWidth); // scrollbarHeight is decimal
            scrollbarXOffset = maxScrollbarTravel * percentTraveled;
        } else {
            displayScrollbar = false;
        }

        this.setState({ // use function in order to prevent re-render on state-change
            scrollbarWidth: `${scrollbarWidth * 100}%`,
            scrollBarXOffset: `${scrollbarXOffset}px`,
            scrollbarDisplay: displayScrollbar,
        });
        if (this.state.scrollBarActive) {
            window.requestAnimationFrame(() => this.updateViewScrollbar(data));
        }
    }

    public render() {

        const scrollbarDisplay = (this.state.scrollBarActive && this.state.scrollbarDisplay) ? "block" : "none";

        return (
            <div ref="container" className="react-horizontal-scrollbar-container">
                <div ref="content" className="react-scrollbar-content">
                    {this.props.children}
                </div>
                <div
                    ref="scrollbar"
                    className="react-scrollbar"
                    style={{
                        display: scrollbarDisplay,
                        width: this.state.scrollbarWidth,
                        left: this.state.scrollBarXOffset,
                    }}
                />
            </div>
        );
    }

    private disableAppTextSelect(): void {
        const app: HTMLElement = document.getElementById("appContainer");

        app.style["-webkit-touch-callout"] = "none";
        app.style["-webkit-user-select"] = "none";
        app.style["-khtml-user-select"] = "none";
        app.style["-moz-user-select"] = "none";
        app.style["-ms-user-select"] = "none";
        app.style["user-select"] = "none";

    }

    private enableAppTextSelect(): void {
        const app: HTMLElement = document.getElementById("appContainer");
        app.style["-webkit-touch-callout"] = "";
        app.style["-webkit-user-select"] = "";
        app.style["-khtml-user-select"] = "";
        app.style["-moz-user-select"] = "";
        app.style["-ms-user-select"] = "";
        app.style["user-select"] = "";
    }
}
